module.exports = __webpack_public_path__ + "static/media/icon.ceb19508.png";